import Calendar, { DEFAULT_OPTIONS } from 'CoreComponents/calendar';

document.querySelectorAll(DEFAULT_OPTIONS['selector']).forEach(calendar => {
  new Calendar(calendar);
});
